import { InspectionReq, InspectionDef } from "../type/inspection-def";

export class InspectionAdapter {
  static toInputDTO(req: InspectionReq): any {
    return {
      nodes: req.nodes.length > 0 ? req.nodes : [],
    };
  }

  static toOutputDTO(res: any): InspectionDef {
    return res;
  }
}
